import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/layouts/Gallery/gallery';
export var Gallery = function Gallery(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$hasGutter = _a.hasGutter,
      hasGutter = _a$hasGutter === void 0 ? false : _a$hasGutter,
      props = __rest(_a, ["children", "className", "hasGutter"]);

  return React.createElement("div", Object.assign({
    className: css(styles.gallery, hasGutter && styles.modifiers.gutter, className)
  }, props), children);
};